import React from 'react';
import styled from 'styled-components';

const EventPropertyValue = styled.div`
  flex: 0 0 auto;
  padding-right: 10px;
  color: ${props => props.theme.colors.white};
`;

export default EventPropertyValue;
